import React from 'react';
import Button from './Button';
import RefreshIcon from './RefreshIcon';
import Tooltip from './Tooltip';

const RefreshButton = ({ onClick }) => (
  <Tooltip text="Refresh data" variant="secondary">
    <Button
      variant="light"
      className="px-[10px] py-[10px]"
      onClick={onClick}
      ariaLabel="Refresh data"
    >
      <RefreshIcon />
    </Button>
  </Tooltip>
);

export default RefreshButton;
